export default "__VITE_ASSET__c002135d__"